import { Box, InputAdornment, TextField } from '@mui/material';
import zeplinColor from 'theme/Color';

const SearchInput = ({
  value,
  handleChange,
  clearInput,
}: {
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  clearInput: () => void;
}) => {
  return (
    <Box
      sx={{
        height: '48px',
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      }}
    >
      <TextField
        variant='outlined'
        placeholder='Search'
        value={value}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <img
                width={20}
                height={20}
                src={'/assets/search-icon.svg'}
                alt='search-project'
                style={{
                  borderRadius: '14px',
                  objectFit: 'fill',
                  cursor: 'pointer',
                }}
              />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position='end' onClick={clearInput}>
              <img
                width={20}
                height={20}
                src={'/assets/clear-input.svg'}
                alt='clear-input'
                style={{
                  borderRadius: '14px',
                  objectFit: 'fill',
                  cursor: 'pointer',
                }}
              />
            </InputAdornment>
          ) : (
            ''
          ),
          sx: {
            borderRadius: '50px',
            border: `1px solid ${zeplinColor.Neutral6}`,
            '&.Mui-focused': { border: `1px solid ${zeplinColor.Neutral6}` },
          },
        }}
        sx={{
          width: '100%',
          height: '48px',
          padding: 0,

          '& .MuiInputBase-input': {
            padding: '12px 12px',
          },
        }}
      />
    </Box>
  );
};

export default SearchInput;
